<template>
  <b-modal id="deliveries-modal" title="Deliveries" size="lg" ok-only>
    <template #modal-title>
      <div class="deliveries-modal-title">
        <span class="title-label">
          Deliveries
        </span>
        <span class="title-meta">
          Latest ENC deliveries
        </span>
      </div>
    </template>
    <div class="modal-section">
      <b-table
          size="sm"
          :items="paginatedDeliveries"
          :fields="fields"
          head-variant="light"
          responsive="sm"
          hover
          class="styled-table"
      >
        <template #cell(timestamp)="data">
          <span class="table-date">{{ formatDate(data.value) }}</span>
        </template>
        <template #cell(url)="data">
          <b-link :href="data.value" target="_blank" class="table-link">
            Download
          </b-link>
        </template>
        <template #empty>
          <div class="text-muted py-4">
            No deliveries yet.
          </div>
        </template>
      </b-table>
    </div>
    <b-pagination
        v-model="currentPage"
        :total-rows="deliveries.length"
        :per-page="perPage"
        align="center"
    class="mt-3 styled-pagination"
    size="sm"
    />
    <div class="text-center mt-3">
      <b-link class="table-link" @click="goToDeliveries">
        Go to deliveries
      </b-link>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    deliveries: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fields: [
        { key: 'type', label: 'Type' },
        { key: 'subType', label: 'Sub Type' },
        { key: 'timestamp', label: 'Date' },
        { key: 'url', label: 'File' }
      ],
      currentPage: 1,
      perPage: 10
    };
  },
  computed: {
    // Пагинация для отображения только части деливерис
    paginatedDeliveries() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.deliveries.slice(start, end);
    }
  },
  methods: {
    // Форматирование даты в удобочитаемый формат
    formatDate(dateString) {
      if (!dateString) return '';
      return new Date(dateString).toLocaleString();
    },
    // Переход к странице с деливерис
    goToDeliveries() {
      this.$bvModal.hide('deliveries-modal');
      this.$router.push('/deliveries');
    }
  }
};
</script>

<style scoped>
.modal-section {
  border: 1px solid #e4e8f5;
  border-radius: 12px;
  padding: 12px;
  background: linear-gradient(135deg, #fbfcff 0%, #f6f8ff 100%);
  box-shadow: 0 4px 16px rgba(34, 45, 80, 0.07);
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif;
}

.styled-table >>> thead tr {
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-size: 0.72rem;
  color: #5c6685;
  background: #eef1fb;
}

.styled-table >>> tbody tr {
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.styled-table >>> tbody tr:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.09);
  background: #ffffff;
}

.styled-table >>> td {
  vertical-align: middle;
  padding: 0.75rem;
  border-top: none;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif;
  font-size: 0.78rem;
  font-weight: 500;
}

.table-date {
  font-weight: 400;
  color: #1f2940;
  letter-spacing: 0.01em;
}

.table-link {
  font-weight: 500;
  color: #3a4256;
  border-bottom: 1px dashed rgba(37, 45, 64, 0.65);
  padding-bottom: 1px;
  text-decoration: none;
  transition: color 0.2s ease;
}

.table-link:hover {
  color: #161b28;
}

.styled-pagination >>> .page-link {
  border-radius: 999px !important;
  margin: 0 4px;
  padding: 6px 12px;
  border: 1px solid rgba(98, 111, 149, 0.25);
  background: rgba(255, 255, 255, 0.95);
  color: #1f2940;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  transition: all 0.18s ease;
  box-shadow: 0 1px 4px rgba(20, 29, 56, 0.08);
}

.styled-pagination >>> .page-item.active .page-link {
  background: linear-gradient(135deg, #f4f6ff, #e9edff);
  color: #2f3760;
  border-color: rgba(98, 111, 149, 0.35);
  box-shadow: 0 6px 14px rgba(31, 41, 64, 0.16);
}

.styled-pagination >>> .page-link:hover {
  color: #151b2c;
  box-shadow: 0 4px 10px rgba(31, 41, 64, 0.12);
}

.styled-pagination >>> .page-item.disabled .page-link {
  opacity: 0.5;
  box-shadow: none;
}

.deliveries-modal-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif;
}

.deliveries-modal-title .title-label {
  color: #1f2940;
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.deliveries-modal-title .title-meta {
  color: #5b6480;
  font-size: 0.74rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

::v-deep #deliveries-modal .modal-header {
  background: linear-gradient(135deg, #f4f6ff 0%, #e6e9ff 100%);
  border-bottom: none;
  padding: 18px 22px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: inset 0 -1px 0 rgba(98, 111, 149, 0.12);
}

::v-deep #deliveries-modal .modal-header .close {
  color: #4b5fdd;
  opacity: 0.75;
  text-shadow: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

::v-deep #deliveries-modal .modal-header .close:hover {
  opacity: 1;
  transform: scale(1.05);
}
</style>